import React from "react"
import { useFormContext } from "react-hook-form"

import Form from "src/components/Form"

const BoatLoaInput = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext()

  return (
    <div>
      <Form.Label htmlFor="trw-new-boat-loa">Length Overall</Form.Label>
      <Form.IconTextField
        icon="ft"
        position="right"
        id="trw-new-boat-loa"
        hasErrors={!!errors?.newBoat?.lengthOverallFeet}
        type="number"
        inputMode="numeric"
        {...register("newBoat.lengthOverallFeet")}
      />
      <div className="absolute bottom-0">
        {errors?.newBoat?.lengthOverallFeet?.message && (
          <Form.Error>{errors.newBoat.lengthOverallFeet.message}</Form.Error>
        )}
      </div>
    </div>
  )
}

export default BoatLoaInput
